import $ from 'cash-dom'

export default class ResourceTiles {
  constructor({ $container } = {}) {
    this.$container = $container
    this.activeSlug = null

    this.constructElements()
    this.constructEvents()
  }

  static init() {
	// NEED
    const $containers = $(ResourceTiles.selectors.container)

    if ($containers.length) {
      $containers.each((i, elem) => {
        const constructed = new ResourceTiles({ $container: $(elem) })
      })
    }
  }

  constructElements() {
	// NEED
    this.$items = this.$container.find(ResourceTiles.selectors.item)
    this.$filters = this.$container.find(ResourceTiles.selectors.filter)
  }

  constructEvents() {
	// NEED
    this.$container
      .on('click', ResourceTiles.selectors.filter, (e) => this.handleClickFilter({ e }))
  }

  doFilterItems({ $container, $filter, categorySlug }) {
	// NEED
    this.activeSlug = categorySlug
	categorySlug = categorySlug == 'all' ? '' : `--${categorySlug}`

    $container
      .find(ResourceTiles.selectors.item)
      .addClass(ResourceTiles.classes.hidden)
      .attr('aria-hidden', true)

    $container
      .find(`${ResourceTiles.selectors.item}${categorySlug}`)
      .removeClass(ResourceTiles.classes.hidden)
      .attr('aria-hidden', false)

    $container
      .find(ResourceTiles.selectors.filterContent)
      .removeClass(ResourceTiles.classes.activeButton)

    $filter
      .find(ResourceTiles.selectors.filterContent)
      .addClass(ResourceTiles.classes.activeButton)
  }

  handleClickFilter({ e }) {
	// NEED
    e.preventDefault()

    const $container = $(e.currentTarget).closest(ResourceTiles.selectors.container)
    const $filter = $(e.currentTarget).closest(ResourceTiles.selectors.filter)
    const $filterContent = $filter.find(ResourceTiles.selectors.filterContent)
    const categorySlug = $filterContent.data('slug')

    if (categorySlug !== this.activeSlug) {
      this.doFilterItems({ $container, $filter, categorySlug })
    }
  }
}

ResourceTiles.selectors = {
  container: '.js-resource-tiles__wrap',
  item: '.js-resource-tiles__item',
  filter: '.js-resource-tiles__filters-item',
  filterContent: '.js-resource-tiles-filter-button',
}

ResourceTiles.classes = {
  hidden: 'c-resource-tiles__item--hidden',
  activeButton: 'c-resource-tiles__filters-button--active',
}
